import React from 'react';
import ViewAdminSchedules from '../ViewAdminSchedules';

const ScheduleByRotationPage = () => <ViewAdminSchedules scheduleType="rotation" />;

export default ScheduleByRotationPage;
